module.exports = __webpack_public_path__ + "img/Fencing.14de0efe.png";